import {AI_ASSISTANT_Z_INDEX} from "../../semantic_search/constants/ai_assistant_z_index";

export const REGISTRATION_FLOW_ABOVE_AI_ASSISTANT_Z_INDEX = AI_ASSISTANT_Z_INDEX + 1;
import {AI_ASSISTANT_Z_INDEX} from "../../semantic_search/constants/ai_assistant_z_index";

export const REGISTRATION_FLOW_ABOVE_AI_ASSISTANT_Z_INDEX = AI_ASSISTANT_Z_INDEX + 1;
